// extracted by mini-css-extract-plugin
export default {"ExpandableString":"ExpandableString_ExpandableString__rPxmn","isExpanded":"ExpandableString_isExpanded__VFwEN"};